import { useEffect, useState } from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';

const CollectionList_5 = ({ item }) => {
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [children, setChildren] = useState([]);
  const [history, setHistory] = useState([]);
  const [customization, setCustomization] = useState(null);

  useEffect(() => {
    const convertedCustomization = staticComponentValueConverter(item?.customization);
    setCustomization(convertedCustomization);

    const initialData = item?.customization?.items?.children || [];
    setChildren(initialData);
  }, [item]);

  const handleTitlePress = item => {
    if (item.children && item.children.length > 0) {
      setHistory([...history, { selectedTitle, children }]);
      setSelectedTitle(item.title);
      setChildren(item.children);
    }
  };

  const handleBackPress = () => {
    if (history.length > 0) {
      const previousState = history.pop();
      setSelectedTitle(previousState.selectedTitle);
      setChildren(previousState.children);
      setHistory([...history]);
    } else {
      setSelectedTitle(null);
      const initialData = item?.customization?.items?.children || [];
      setChildren(initialData);
    }
  };

  const renderItem = item => (
    <div
      key={item.id}
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: customization?.gap,
        paddingBottom: customization?.gap,
        borderBottom: `1px solid ${customization?.borderColor}`,
      }}
      onClick={() => handleTitlePress(item)}
    >
      <span
        style={{
          textAlign: 'left',
          flex: 1,
          fontSize: customization?.textSize,
          fontWeight: customization?.textWeight,
          color: customization?.textColor,
        }}
      >
        {item.title}
      </span>
      {item.children && item.children.length > 0 && (
        <svg width="24px" height="24px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="48" height="48" fillOpacity="0.01" />
          <path
            d="M19 12L31 24L19 36"
            style={{ stroke: customization?.textColor }}
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  );

  return (
    <div
      style={{
        padding: `${customization?.containerPadding}`,
        backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
        backgroundImage:
          customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
      className="pointer-events-auto cursor-pointer"
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          paddingTop: customization?.containerPadding?.[0],
          paddingRight: customization?.containerPadding?.[1],
          paddingBottom: customization?.containerPadding?.[2],
          paddingLeft: customization?.containerPadding?.[3],
        }}
      >
        {selectedTitle && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: `1px solid ${customization?.borderColor}`,
              paddingTop: customization?.gap,
              paddingBottom: customization?.gap,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '5px',
                flex: 1,
              }}
              onClick={handleBackPress}
            >
              <svg width="24px" height="24px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" fillOpacity="0.01" />
                <path
                  d="M29 12L17 24L29 36"
                  style={{ stroke: customization?.textColor }}
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span
                style={{
                  fontSize: customization?.textSize,
                  fontWeight: customization?.textWeight,
                  color: customization?.textColor,
                  cursor: 'pointer',
                  maxWidth: 135,
                }}
                className="truncate"
              >
                {selectedTitle || ''}
              </span>
            </div>
            <button
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
              }}
            >
              <span
                style={{
                  color: customization?.textColor,
                  fontSize: customization?.textSize,
                  fontWeight: customization?.textWeight,
                  textDecoration: 'underline',
                }}
                className="truncate"
              >
                Tümünü Gör
              </span>
            </button>
          </div>
        )}

        <div>{children.map(child => renderItem(child))}</div>
      </div>
    </div>
  );
};

export default CollectionList_5;
